export default __webpack_public_path__ + "static/media/mindzbook phone done.5f0cbf52.png";